import type { StaticSharedField } from './types';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useVehicleSize(
  vehicleSizesList: { name: string; title: string; subtitle: string }[],
): StaticSharedField {
  return {
    propName: 'vehicle_size',
    element: 'vehicle_size',
    type: FIELD_TYPE_DROPDOWN,
    label: 'Vehicle size:',
    values: [
      { name: null, displayName: 'Select a vehicle size' },
      ...(vehicleSizesList.length > 0
        ? vehicleSizesList.map((val) => ({
            name: val.name,
            displayName: `${val.title} ${val.subtitle}`,
          }))
        : []),
    ],
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOVEHICLESIZE',
        errStr: 'Please select a vehicle size',
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERRVEHICLESIZENOTFOUND',
        errStr: 'Vehicle size not found',
      },
    ],
  };
}
